import React from "react";
import { Shaders, Node } from "gl-react";
import { frag } from "./daltonize-shader";

import interpolate from "interpolate-range";

const shaders = Shaders.create({
  normalize: { frag }
});

// const Modes = {
//   NORMAL: 0,
//   PROTANOPE: 1,
//   DEUTERANOPE: 2,
//   TRITANOPE: 3
// };

const soften = interpolate({
  inputRange: [0, 1],
  outputRange: [0, 0.35],
  clamp: true
});

export const Normalize = ({ children, intensity, daltonism, step = 3 }) => {
  if (daltonism === 3) {
    intensity = soften(intensity);
  }
  return (
    <Node
      shader={shaders.normalize}
      uniforms={{ children, cbtype: daltonism, intensity, step }}
    />
  );
};
